import SystemNotification, { SystemNotificationApplication, SystemNotificationResponse } from "../../Components/Notifications/Models/SystemNotification";
import { abpnClient } from "../AbpnClient";

class SystemNotificationService {
   
    async getSystemNotifications(authContext : any) : Promise<SystemNotification[]> {
        return await abpnClient.get<SystemNotification[]>("/api/physician/GetSystemNotifications", authContext);
    }

    async saveSystemNotificationResponse(response : Partial<SystemNotificationResponse>, authContext : any) {
        await abpnClient.post("/api/physician/SaveSystemNotificationResponse", {
            systemNotificationApplicationId: SystemNotificationApplication.PhysicianPortal,
            systemNotificationId: response.systemNotificationId,
            primaryActionTaken: response.primaryActionTaken,
            permanentlyDismiss: response.permanentlyDismiss,
            personKey: response.personKey
        }, authContext);
    }
    
}

const systemNotificationService = new SystemNotificationService();
export default systemNotificationService;